import React from 'react'
import styled from 'styled-components'
import { ClientsFirst } from '../Components/Clients/ClientsFirst'
import { colors } from '../Shared/colors'

export const ClientsComponent = () => {
  return (
    <Main>
        <ClientsFirst/>
        {/* <ClientsDatatable/> */}
    </Main>
  )
}


const Main = styled.div`
  background: linear-gradient(135deg, ${colors.inputWhite} 0%, ${colors.white} 100%);
min-height: calc(100vh - 10vh);
margin-top: 10vh;
display: flex;
  padding: 2rem 0;
flex-direction: column;
  justify-content: flex-start;
align-items: center;
  width: 100%;
`